/* global DefaultRequestBridge */

import {createAction} from 'redux-actions';

import {Medium} from '../../base/actions';

const downloadStartedAction = createAction(Medium.download.started);

const downloadProgressAction = createAction(Medium.download.progress, (
    (remote, loaded, total) => ({remote, loaded, total})
));

const downloadFinishedAction = createAction(Medium.download.finished, (remote, local) => ({remote, local}));

const downloadFailedAction = createAction(Medium.download.failed, (remote, error) => ({remote, error}));

export const download = remoteURL => (dispatch, getState) => {
    const {media} = getState();
    const {total = 0, local} = media[remoteURL] || {};

    if (local || total >= 1) return false;  /* download finished or already in progress */

    const handleProgress = ({loaded, total}) => {
        dispatch(downloadProgressAction(remoteURL, loaded, total));
    };

    const handleSuccess = localURL => {
        dispatch(downloadFinishedAction(remoteURL, localURL));
    };

    const handleFailure = error => {
        dispatch(downloadFailedAction(remoteURL, error));
    };

    DefaultRequestBridge.downloadFile(remoteURL, handleProgress).then(handleSuccess).catch(handleFailure);

    return dispatch(downloadStartedAction(remoteURL));
};



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/actionCreators/medium.js